import { ErrorState, ForbiddenState } from "@/ds";
import { ObrasCards } from "../obras-cards";
import { ObrasEmpty } from "../obras-empty";
import type { ObrasCardsViewViewModel } from "./types-obras-cards-view";

/**
 * Visão Cards: Kanban com uma coluna por status da obra (ordem e rótulo da visão Obra), 10 por coluna e "Mostrar mais
 * obras".
 */
export function ObrasCardsViewView({
  search,
  filters,
  isMobile,
  statusState,
  statusError,
  onClearSearch,
  onClearFilters,
  state,
  loadMore,
  forbidden,
  isEmpty,
  visibleColumns,
}: ObrasCardsViewViewModel) {
  if (statusState === "forbidden") {
    return <ForbiddenState description={statusError ?? undefined} testId="obras-forbidden" />;
  }

  if (statusState === "error") {
    return (
      <ErrorState
        message="Não foi possível carregar as obras."
        description={statusError ?? undefined}
        testId="obras-error"
      />
    );
  }

  if (forbidden) {
    return (
      <ForbiddenState
        description="Você não tem permissão para consultar as obras."
        testId="obras-forbidden"
      />
    );
  }

  if (isEmpty) {
    return (
      <ObrasEmpty
        search={search}
        filters={filters}
        onClearSearch={onClearSearch}
        onClearFilters={onClearFilters}
      />
    );
  }

  return (
    <ObrasCards
      isLoading={statusState === "loading"}
      isMobile={isMobile}
      columns={visibleColumns}
      state={state}
      onLoadMore={loadMore}
    />
  );
}
